/* AURORA GLUE — The Nine Aurora (2026-08-16)
   Interpolation-free end-of-body scripts externalized from the theme so the
   HTML payload shrinks and the browser can cache them. Loaded once from
   layout/theme.liquid with defer. Both blocks are self-contained IIFEs that
   drive themselves via load/MutationObserver/interval, so behavior under
   defer is identical to the old inline placement.

   1. Gorgias launcher skin      (was snippets/aurora-gorgias-skin.liquid)
   2. EqualWeb + Google merchant
      widget positioning         (was snippets/google-merchant-widget.liquid)
*/

/* ============================================================
   1. AURORA GORGIAS SKIN (JS part — the CSS stays in the snippet)
   ============================================================ */
/* Aurora skin for the Gorgias launcher — injected into its same-origin
   srcdoc iframe. Fully defensive: on any failure the stock widget stays. */
(function () {
  'use strict';
  var LOGO = 'https://cdn.shopify.com/s/files/1/0648/1523/5203/files/Logo_Aurora_W.svg?v=1751384228';
  var LAUNCHER_CSS = [
    '#gorgias-chat-messenger-button{',
    '  position:relative!important;',
    '  background:#585179!important;',
    '  border-radius:999px!important;',
    '  transition:background-color .3s ease, transform .3s ease!important;',
    '}',
    '#gorgias-chat-messenger-button:hover{background:#EB5D5B!important;transform:translateY(-2px);}',
    '#gorgias-chat-messenger-button:focus-visible{outline:2px solid #FBF3EC!important;outline-offset:3px!important;}',
    '#gorgias-chat-messenger-button>div{display:none!important;}',
    '#gorgias-chat-messenger-button::after{',
    '  content:"";position:absolute;inset:0;',
    '  background:url(' + LOGO + ') center / 56% no-repeat;',
    '}',
    '#gorgias-chat-messenger-button[aria-expanded="true"]::after{',
    '  content:"\\2715";background:none;color:#FBF3EC;',
    '  display:flex;align-items:center;justify-content:center;',
    '  font:300 22px/1 "Helvetica Neue", Arial, sans-serif;',
    '}',
    '@media (prefers-reduced-motion: reduce){',
    '  #gorgias-chat-messenger-button{transition:none!important;}',
    '  #gorgias-chat-messenger-button:hover{transform:none;}',
    '}'
  ].join('\n');
  var WINDOW_CSS = [
    'a[href*="gorgias.com"],[class*="poweredBy"],[class*="powered-by"]{display:none!important;}',
    /* Greeting-screen logo (owner 2026-08-03: "white and smaller"): the
       header picture is locked to Gorgias-hosted files the API refuses to
       replace, so swap it visually here. Keyed on the two exact header
       picture files so agent avatars are never touched. */
    'img[src*="2c32920f-8a78-4167-a00c-db064d7a1e1b"],img[src*="66b54287-5b58-4563-a5c1-d3446dccb7d5"]{',
    '  content:url(' + LOGO + ');',
    '  height:44px!important;width:auto!important;max-width:120px!important;',
    '  object-fit:contain!important;border-radius:0!important;background:none!important;',
    '}'
  ].join('\n');

  function inject(frameId, css, markId) {
    try {
      var f = document.getElementById(frameId);
      if (!f) return false;
      var d = f.contentDocument;
      if (!d || !d.head) return false;
      if (d.getElementById(markId)) return true;
      var s = d.createElement('style');
      s.id = markId;
      s.textContent = css;
      d.head.appendChild(s);
      return true;
    } catch (e) { return false; }
  }

  /* JS fallback for the greeting logo (owner 2026-08-03 "the widget is
     not done"): the CSS content:url swap misses the picture when Gorgias
     renders it as a background-image or re-creates the node, so rewrite
     it directly. Keyed on the two exact header-picture filenames. */
  var HEADER_PICS = /2c32920f-8a78-4167-a00c-db064d7a1e1b|66b54287-5b58-4563-a5c1-d3446dccb7d5/;
  function swapLogo(frameId) {
    try {
      var f = document.getElementById(frameId);
      var d = f && f.contentDocument;
      if (!d || !d.body) return;
      var imgs = d.getElementsByTagName('img');
      for (var i = 0; i < imgs.length; i++) {
        var im = imgs[i];
        if (!HEADER_PICS.test(im.src || '') || im.getAttribute('data-aurora-logo')) continue;
        im.setAttribute('data-aurora-logo', '1');
        im.src = LOGO;
        im.style.setProperty('height', '44px', 'important');
        im.style.setProperty('width', 'auto', 'important');
        im.style.setProperty('max-width', '120px', 'important');
        im.style.setProperty('object-fit', 'contain', 'important');
        im.style.setProperty('border-radius', '0', 'important');
        im.style.setProperty('background', 'none', 'important');
      }
      var all = d.querySelectorAll('div,span,section,header');
      for (var j = 0; j < all.length; j++) {
        var el = all[j];
        if (el.getAttribute('data-aurora-logo')) continue;
        var bg = (el.currentStyle || (d.defaultView && d.defaultView.getComputedStyle(el))) || null;
        var bi = bg && bg.backgroundImage;
        if (!bi || !HEADER_PICS.test(bi)) continue;
        el.setAttribute('data-aurora-logo', '1');
        el.style.setProperty('background-image', 'url(' + LOGO + ')', 'important');
        el.style.setProperty('background-size', 'auto 44px', 'important');
        el.style.setProperty('background-repeat', 'no-repeat', 'important');
        el.style.setProperty('background-position', 'center', 'important');
      }
    } catch (e) { /* fail closed — stock widget stays */ }
  }

  function pass() {
    inject('chat-button', LAUNCHER_CSS, 'aurora-gorgias-skin');
    inject('chat-input', WINDOW_CSS, 'aurora-gorgias-skin');
    inject('chat-campaigns', WINDOW_CSS, 'aurora-gorgias-skin');
    swapLogo('chat-input');
    swapLogo('chat-campaigns');
    try {
      if (window.GorgiasChat && typeof window.GorgiasChat.hidePoweredBy === 'function' && !pass._pb) {
        pass._pb = true;
        window.GorgiasChat.hidePoweredBy(true);
      }
    } catch (e) { /* keep going — cosmetic only */ }
  }

  /* Gorgias injects late and can rebuild its srcdoc frames; keep a fast
     watch for the first two minutes, then a slow permanent one — the
     greeting screen is rebuilt INSIDE the iframe whenever the chat opens,
     where the parent-page MutationObserver cannot see it. */
  var tries = 0;
  var timer = setInterval(function () {
    pass();
    if (++tries > 90) {
      clearInterval(timer);
      setInterval(pass, 4000);
    }
  }, 1300);

  var mo = null;
  function watchContainer() {
    var cont = document.getElementById('gorgias-chat-container');
    if (!cont || mo) return;
    mo = new MutationObserver(function () { pass(); });
    mo.observe(cont, { childList: true, subtree: true });
  }
  if ('MutationObserver' in window) {
    new MutationObserver(watchContainer).observe(document.documentElement, { childList: true, subtree: true });
    watchContainer();
  }
})();

/* ============================================================
   2. EQUALWEB + GOOGLE MERCHANT WIDGET POSITIONING
   ============================================================ */
(function () {
  function settings() {
    var mobile = window.innerWidth <= 768;
    return {
      googleSize: 44,
      equalWebSize: 30,
      gap: 6,
      left: mobile ? 12 : 16,
      googleBottom: mobile ? 8 : 10,
      equalWebBottom: mobile ? 12 : 14
    };
  }

  function removeCustomEqualWebDuplicate() {
    var duplicate = document.getElementById('tna-equalweb-trigger');
    if (duplicate) duplicate.remove();
  }

  function fixedRoot(el) {
    var current = el;
    while (current && current !== document.body) {
      if (window.getComputedStyle(current).position === 'fixed') return current;
      current = current.parentElement;
    }
    return el;
  }

  function placeEqualWeb() {
    removeCustomEqualWebDuplicate();

    var buttons = document.querySelectorAll('[id="INDmenu-btn"]');
    if (!buttons.length) return false;

    var button = buttons[0];
    for (var i = 1; i < buttons.length; i++) {
      buttons[i].remove();
    }

    var s = settings();
    var root = fixedRoot(button);
    var left = s.left + s.googleSize + s.gap;

    root.setAttribute('data-tna-equalweb-root', 'true');
    root.style.setProperty('display', 'block', 'important');
    root.style.setProperty('visibility', 'visible', 'important');
    root.style.setProperty('opacity', '1', 'important');
    root.style.setProperty('pointer-events', 'auto', 'important');
    root.style.setProperty('position', 'fixed', 'important');
    root.style.setProperty('left', left + 'px', 'important');
    root.style.setProperty('right', 'auto', 'important');
    root.style.setProperty('bottom', s.equalWebBottom + 'px', 'important');
    root.style.setProperty('top', 'auto', 'important');
    root.style.setProperty('width', s.equalWebSize + 'px', 'important');
    root.style.setProperty('height', s.equalWebSize + 'px', 'important');
    root.style.setProperty('min-width', s.equalWebSize + 'px', 'important');
    root.style.setProperty('min-height', s.equalWebSize + 'px', 'important');
    root.style.setProperty('max-width', s.equalWebSize + 'px', 'important');
    root.style.setProperty('max-height', s.equalWebSize + 'px', 'important');
    root.style.setProperty('margin', '0', 'important');
    root.style.setProperty('padding', '0', 'important');
    root.style.setProperty('transform', 'none', 'important');
    root.style.setProperty('transform-origin', 'bottom left', 'important');
    root.style.setProperty('overflow', 'visible', 'important');
    root.style.setProperty('z-index', '2147483000', 'important');

    button.style.setProperty('display', 'flex', 'important');
    button.style.setProperty('align-items', 'center', 'important');
    button.style.setProperty('justify-content', 'center', 'important');
    button.style.setProperty('visibility', 'visible', 'important');
    button.style.setProperty('opacity', '1', 'important');
    button.style.setProperty('pointer-events', 'auto', 'important');
    button.style.setProperty('position', root === button ? 'fixed' : 'absolute', 'important');
    button.style.setProperty('left', root === button ? left + 'px' : '0', 'important');
    button.style.setProperty('right', 'auto', 'important');
    button.style.setProperty('bottom', root === button ? s.equalWebBottom + 'px' : '0', 'important');
    button.style.setProperty('top', 'auto', 'important');
    button.style.setProperty('width', s.equalWebSize + 'px', 'important');
    button.style.setProperty('height', s.equalWebSize + 'px', 'important');
    button.style.setProperty('min-width', s.equalWebSize + 'px', 'important');
    button.style.setProperty('min-height', s.equalWebSize + 'px', 'important');
    button.style.setProperty('max-width', s.equalWebSize + 'px', 'important');
    button.style.setProperty('max-height', s.equalWebSize + 'px', 'important');
    button.style.setProperty('margin', '0', 'important');
    button.style.setProperty('padding', '0', 'important');
    button.style.setProperty('transform', 'none', 'important');
    button.style.setProperty('transform-origin', 'center', 'important');
    button.style.setProperty('background-size', 'contain', 'important');
    button.style.setProperty('background-position', 'center', 'important');
    button.style.setProperty('background-repeat', 'no-repeat', 'important');
    button.style.setProperty('z-index', '2147483000', 'important');

    var media = button.querySelectorAll('svg, img');
    for (var j = 0; j < media.length; j++) {
      media[j].style.setProperty('width', '100%', 'important');
      media[j].style.setProperty('height', '100%', 'important');
      media[j].style.setProperty('max-width', '100%', 'important');
      media[j].style.setProperty('max-height', '100%', 'important');
      media[j].style.setProperty('object-fit', 'contain', 'important');
    }

    return true;
  }

  function excluded(el) {
    if (!el || !el.getAttribute) return true;
    var text = ((el.id || '') + ' ' + (el.className || '') + ' ' + (el.tagName || '')).toLowerCase();
    return /iubenda|indmenu|equalweb|accessibility-button|tna-equalweb|gorgias|shopify-chat|chat-widget|merchantwidgetscript/.test(text);
  }

  function findGoogleWidget() {
    var remembered = document.querySelector('[data-tna-google-widget="true"]');
    if (remembered) return remembered;

    var selectors = [
      'iframe[src*="shopping"]',
      'iframe[src*="merchant"]',
      '[id*="merchant"]',
      '[class*="merchant"]',
      '[title*="Google"]',
      '[aria-label*="Google"]'
    ];

    for (var i = 0; i < selectors.length; i++) {
      var matches = document.querySelectorAll(selectors[i]);
      for (var j = 0; j < matches.length; j++) {
        var candidate = fixedRoot(matches[j]);
        if (!candidate || candidate.tagName === 'SCRIPT' || excluded(candidate)) continue;
        var rect = candidate.getBoundingClientRect();
        if (rect.width >= 30 && rect.width <= 180 && rect.height >= 30 && rect.height <= 180 && rect.left < 220) {
          return candidate;
        }
      }
    }

    var all = document.querySelectorAll('body *');
    var best = null;
    var bestScore = Infinity;

    for (var k = 0; k < all.length; k++) {
      var el = all[k];
      if (el.tagName === 'SCRIPT' || el.tagName === 'STYLE' || excluded(el)) continue;

      var style = window.getComputedStyle(el);
      if (style.position !== 'fixed') continue;

      var r = el.getBoundingClientRect();
      var bottomDistance = window.innerHeight - r.bottom;
      if (r.width < 30 || r.height < 30 || r.width > 180 || r.height > 180) continue;
      if (r.left > 220 || bottomDistance > 140 || bottomDistance < -20) continue;

      var score = r.left + Math.abs(bottomDistance) + Math.abs(r.width - r.height);
      if (score < bestScore) {
        best = el;
        bestScore = score;
      }
    }

    return best;
  }

  function placeGoogleWidget() {
    var s = settings();
    var google = findGoogleWidget();
    if (!google) return false;

    var naturalSize = parseFloat(google.getAttribute('data-tna-natural-size'));
    if (!naturalSize) {
      naturalSize = Math.max(google.offsetWidth || 0, google.offsetHeight || 0);
      if (!naturalSize) {
        var rect = google.getBoundingClientRect();
        naturalSize = Math.max(rect.width || 0, rect.height || 0);
      }
      if (naturalSize) google.setAttribute('data-tna-natural-size', naturalSize);
    }
    if (!naturalSize) return false;

    google.setAttribute('data-tna-google-widget', 'true');
    google.style.setProperty('position', 'fixed', 'important');
    google.style.setProperty('left', s.left + 'px', 'important');
    google.style.setProperty('right', 'auto', 'important');
    google.style.setProperty('bottom', s.googleBottom + 'px', 'important');
    google.style.setProperty('top', 'auto', 'important');
    google.style.setProperty('transform-origin', 'bottom left', 'important');
    google.style.setProperty('transform', 'scale(' + (s.googleSize / naturalSize) + ')', 'important');
    google.style.setProperty('z-index', '2147482999', 'important');

    return true;
  }

  function applyLayout() {
    removeCustomEqualWebDuplicate();
    placeGoogleWidget();
    placeEqualWeb();
  }

  window.addEventListener('load', applyLayout);
  window.addEventListener('resize', function () {
    setTimeout(applyLayout, 100);
  });

  var observer = new MutationObserver(applyLayout);
  observer.observe(document.documentElement, { childList: true, subtree: true });

  var attempts = 0;
  var timer = setInterval(function () {
    attempts += 1;
    applyLayout();
    if (attempts >= 120) clearInterval(timer);
  }, 250);

  setInterval(applyLayout, 1500);
  applyLayout();
})();
